<table  style="margin: 1rem; width:95%;" class="table table-striped table-hover" data-row-style="rowStyle">
    <thead>
      <tr class="t-header">
        <th class="" scope="col" colspan='2'>
          <div  class="actionPadding" title="Name">SMS Details</div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td> Board Member Name</td>
        <td>{{smsDetails.member_name | titlecase}}</td>
      </tr>
      <tr>
        <td>  Phone Number</td>
        <td>{{smsDetails.to}}</td>
      </tr>
      <tr>
        <td> Inbound SID</td>
        <td>{{smsDetails.inbound_sid}}</td>
      </tr>
      <tr>
        <td> Outbound SID</td>
        <td>{{smsDetails.outbound_sid}}</td>
      </tr>
      <tr>
        <td> Response</td>
        <td>{{smsDetails.response}}</td>
      </tr>
      <tr *ngIf="pollType == 'ranked-choice'" >
        <td> Voting Preference</td>
        <td>{{smsDetails.user_ranking}}</td>
      </tr>
      <tr>
        <td> Replied</td>
        <td>{{smsDetails.replied}}</td>
      </tr>
      <tr *ngIf="pollType != 'ranked-choice'" >
        <td> Matched Option</td>
        <td>
          <div>
            {{smsDetails.parsed_response  ? smsDetails.parsed_response : 'No Reply'}} 
            <mat-icon (click)= "openEditManualUpdateResult()">create</mat-icon>
          </div>
          
          
        </td>
      </tr>
      <tr>
        <td> Error</td>
        <td>{{smsDetails.error}}</td>
      </tr>
      <tr>
        <td> Error Code</td>
        <td>{{smsDetails.error_code}}</td>
      </tr>
      <tr>
        <td> Poll Execution Time</td>
        <td>{{smsDetails.created_at}}</td>
      </tr>
      <tr>
        <td> Last Reply Time</td>
        <td *ngIf=!smsDetails.replied></td>
        <td *ngIf=smsDetails.replied>{{smsDetails.updated_at}}</td>
      </tr>
      
        <!--company_id: 4
created_at: "2021-02-12T15:40:16.439655+05:30"
error: ""
error_code: 0
from: "+17076002604"
id: 3
inbound_sid: "SMeb97da46b5fe463fb6487d874c79b458"
matched_option: 19
member_id: 1
member_name: "John"
outbound_sid: "SMdc5c01a0ff06f2844b0cc86e63775c5c"
parsed_response: "Vote for Ravi"
poll_execute_id: 11
poll_id: 12
replied: true
response: "RAVI 1"
status: ""
to: "+13093265848"
updated_at: "2021-02-12T15:49:12.752592+05:30"-->
    </tbody>
</table>